class LocalStorage {
    static names = {
        locale: 'dydu.bms-front.locale',
    };

    static locale = Object.create({
        save: (data: string) => localStorage.setItem(LocalStorage.names.locale, data),
        load: () => localStorage.getItem(LocalStorage.names.locale) || null,
        remove: () => localStorage.removeItem(LocalStorage.names.locale),
    });
}

export default LocalStorage;
